import { defineMessages } from 'react-intl'

const scope = 'procurify.expense.components.ExpenseTaxSelect'

export default defineMessages({
  taxTypePercent: {
    id: `${scope}.taxTypePercent`,
    defaultMessage: '%',
  },
  taxTypeDollar: {
    id: `${scope}.taxTypeDollar`,
    defaultMessage: '$',
  },
})
